/* eslint no-unused-vars:0 */
import styled from 'styled-components';
import StringToJSX from '../../StringToJSX';
import { WCAG_STYLE } from '../../../common/styles';
import { h } from 'preact';
const StyledInvitationBody = styled.div`
  display: table;
  margin: 0 auto;
  margin-bottom: 46px;
  margin-top: 20px;
  padding-right: 10px;
  padding-left: 10px;

  ${({ isInviteReflow }) => isInviteReflow ? `
    @media screen and (max-width: 250px) {
      padding: 0;
    }
  ` : ''};

  &.neb-wcag a:focus {
    ${WCAG_STYLE}
  }

  &.wcag-link-contrast a {
    color: #0071eb;
  }

  &.wcag-link-contrast a {
    &:hover,
    &:link,
    &:focus,
    &:active,
    &:visited {
      text-decoration: underline;
    }
  }
`;

export default props => (
  // all the margin-top-20 paddig-left-10 etc.. has been transfered from the old invitation
  // in order to support customs old css files
  <StyledInvitationBody
    isInviteReflow={props.isInviteReflow}
    className={`invitationHeadlineParent margin-top-20 padding-left-10 padding-right-10 margin-bottom-46 ${
      props.isWCAG ? 'neb-wcag wcag-link-contrast' : ''
    }`}
  >
    <div>
      <StringToJSX content={props.content} />
    </div>
  </StyledInvitationBody>
);
